import BaseEntity from '../BaseEntity.model';
import { CreatedBy } from '../Shared/CreatedBy.model';
import { SingleNeedComment } from './SingleNeedComment.model';

export default interface ISingleNeed extends BaseEntity {
    CurrentNeedsId: string;
    MemberId: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;

    OptionLabel: string;
    OptionLabelOther: string;
    IsMet: string;
    HowNeedWasMet: string;
    Comments: string;
    NeedComments: SingleNeedComment[];
    IsAI: boolean;
}

export class SingleNeed implements ISingleNeed {
    Id: string;
    CurrentNeedsId: string;
    MemberId: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;

    OptionLabel: string;
    OptionLabelOther: string;
    IsMet: string;
    HowNeedWasMet: string;
    Comments: string;
    NeedComments: SingleNeedComment[];
    IsAI: boolean;

    constructor() {
        this.Id = '';
        this.CurrentNeedsId = '';
        this.MemberId = '';

        this.OptionLabel = '';
        this.OptionLabelOther = '';
        this.IsMet = '';
        this.HowNeedWasMet = '';
        this.Comments = '';
        this.NeedComments = [];
        this.IsAI = false;
    }
}
